import React from 'react';
import ServicePageHero from '../ServicePageHero/ServicePageHero';

const ServiceYardCareHero = () => (
  <ServicePageHero
    breadcrumbLabel="Complete Yard Care"
    titlePrimary="Your yard, looked after"
    titleAccent=" all year long."
    subtext="Reliable, thorough maintenance that keeps your outdoor space healthy and beautiful through every Colorado season, without you having to think about it."
  />
);

export default ServiceYardCareHero;
